import React, {useCallback, useEffect, useState} from 'react';
import StringUtils from "common/stringUtils";
import {useTranslation} from "react-i18next";

type Props = {
  callNonInoutInfo: () => Promise<void>;
  nonInoutTotalBalance: number;
  nonInoutInfoDetail: Array<NonInoutInfoDetail>;
}
const NonInoutInfo: React.FC<Props> = ({callNonInoutInfo, nonInoutTotalBalance, nonInoutInfoDetail}) => {

    const krw = "KRW";
    const {t} = useTranslation();
    const [product, setProduct] =
        useState<Array<{ cardProductCode: "", cardProductCodeName: ""}>>([]);

    // 미납된 카드상품명 표기 처리
    const putCardProductCode = useCallback(() => {
        let cardArray: any[] = [];
        for(let i=0; i < nonInoutInfoDetail.length; i++) {
            let object = {
                cardProductCode: "",
                cardProductCodeName: ""
            }
            let existingProduct = cardArray.find(item => item.cardProductCode === nonInoutInfoDetail[i].cardProductCode);
            if(!existingProduct) {
                object.cardProductCode = nonInoutInfoDetail[i].cardProductCode;
                object.cardProductCodeName = nonInoutInfoDetail[i].cardProductCodeName;
                cardArray.push(object);
            }
        }
        setProduct(cardArray);
    }, [nonInoutInfoDetail]);

    useEffect(() => {
        callNonInoutInfo();
    }, [callNonInoutInfo]);

    useEffect(() => {
        putCardProductCode();
    }, [nonInoutInfoDetail, putCardProductCode]);

    // 정렬 순서 100922:프리미엄, 100921:드림, 103079:웰컴, 101007:다이렉트
    const cardSortStandard = ['100922', '100921', '103079', '101007'];
    const sortedProduct = product.sort((a, b) => {
        const indexA = cardSortStandard.indexOf(a.cardProductCode);
        const indexB = cardSortStandard.indexOf(b.cardProductCode);
        return indexA - indexB;
    });

    return (
        <div className='nonInoutInfoWrap'>
            <section className='nonInoutInfoTitle'>
                <div className='Total-Pending-Fee'>{t('SERV16.fee.total')}</div>
                <div className='Total-KRW'>{`${StringUtils.moneyFormat(nonInoutTotalBalance)} ${krw}`}</div>
            </section>
            <div className='Line'/>
            <div className='Divider'/>
            {sortedProduct
                .sort((a, b) => cardSortStandard.indexOf(a.cardProductCodeName) - cardSortStandard.indexOf(b.cardProductCodeName))
                .map((productItem:any, productIndex:number) => {
                return (
                    <div className='nonInoutInfo' key={productIndex}>
                        <div className='Card-Product-Code'>
                            <img className='Card-Product-Image' src={`/assets/images/content/gmoney-card-Illustration_${productItem.cardProductCode}.png`} alt={"cardProductCode"} />
                            {productItem.cardProductCodeName.charAt(0) + productItem.cardProductCodeName.slice(1).toLowerCase().replace(" card"," Card")}
                        </div>
                        <div className='nonInoutInfoDetail'>
                            {nonInoutInfoDetail.map((nonInoutInfoItem: NonInoutInfoDetail, nonInoutInfoIndex: number) => (
                                productItem.cardProductCode === nonInoutInfoItem.cardProductCode
                                    ? (
                                        <section key={'nonInoutInfoDetail' + nonInoutInfoIndex} className='nonInoutSection'>
                                            <div className='-Fee, circle'>{t('SERV16.fee.' + nonInoutInfoItem.accountDivisionCode)} : {`${StringUtils.moneyFormat(nonInoutInfoItem.inoutBalance)} ${krw}`}</div>
                                        </section>
                                    ) : ''
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default NonInoutInfo;
